export const LOCALE_EN = 'en';
export const SUPPORTED_LANGUAGES = [LOCALE_EN];
